import { render } from "./NoticesList.vue?vue&type=template&id=58e53c8e"
import script from "./NoticesList.vue?vue&type=script&lang=js"
export * from "./NoticesList.vue?vue&type=script&lang=js"

import "./NoticesList.vue?vue&type=style&index=0&id=58e53c8e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__